import React from 'react';
import { ClipboardList, Phone } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';

export default function IntakeForm() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-cyan-50">
      <Seo title="New Client Intake Form" path="/intake-form" description="First visit to Bubbles & Bark? Complete our new client intake form so we know all about your pet before their spa day." />
      <Header showContactInfo={true} showBookNowButton={true} />

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <ClipboardList className="w-8 h-8 text-pink-600" />
            <h1 className="text-4xl font-bold text-gray-800">New Client Intake Form</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            First visit with us? Tell us about your pet before you come in — their health,
            temperament and grooming needs — so we can give them the best possible care.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="w-full h-[1000px]">
            <iframe
              src="https://form.moego.pet/go/form?formId=98560024b9fe49a987961877717ac7d9"
              width="100%"
              height="100%"
              frameBorder="0"
              title="New client intake form"
            ></iframe>
          </div>
        </div>

        {/* The form is third-party, so always leave a way through */}
        <div className="text-center mt-8">
          <p className="text-gray-600 mb-3">Having trouble with the form?</p>
          <a
            href="tel:+14078688608"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-cyan-500 hover:from-pink-600 hover:to-cyan-600 text-white px-6 py-3 rounded-full font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <Phone className="w-4 h-4" />
            <span>Call us on (407) 868-8608</span>
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
